<template>
  <div class="chart-item-link">
    <div class="wrapper">
      <div class="chart-wrapper">
        <div v-if="showBoth" class="left-link" @click="onGoBack" />
        <div v-if="showBoth" class="right-link" @click="onGoForward" />
        <div v-if="!showBoth" class="single-link" @click="onNavigate" />
        <svg viewBox="0 0 550 400" />
        <div :class="image" />
        <div class="chart-title">
          <h4>{{text}}</h4>
        </div> 
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    components: {
    },

    props: {
      canGoForward: {type: Boolean, default: true},
      canGoBack: {type: Boolean, default: false},
    },

    computed: {
      text() {
        if (this.canGoBack && this.canGoForward) {
          return 'Back / Next'
        } else if (this.canGoBack) {
          return 'Previous Page'
        } else {
          return 'Next Page'
        }
      },

      image() {
        if (this.canGoBack && this.canGoForward) {
          return 'arrow-both'
        } else if (this.canGoBack) {
          return 'arrow-left'
        } else {
          return 'arrow-right'
        }
      },

      showBoth() {
        return this.canGoBack && this.canGoForward
      },
    },

    methods: {
      onGoBack() {
        this.$emit("onGoBack")
      },

      onGoForward() {
        this.$emit("onGoForward")
      },

      onNavigate() {
        if (this.canGoBack) {
          this.$emit("onGoBack")
        } else {
          this.$emit("onGoForward")
        }
      },
    },
  }
</script>

<style lang="sass">
  @import 'raypro_ui/src/styles/base/_variables.sass'
  @import 'raypro_ui/src/styles/helpers/_mixins.sass'
  @import '../../../stylesheets/helpers/mixins'

  .chart-item-link
    width: 100%
    max-width: 320px
    position: relative
    cursor: pointer
    background-color: $color-panel-bg
    box-shadow: $color-shadow
    margin-bottom: 30px
    margin-right: 30px
    border-radius: 20px
    -moz-box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.06)
    -webkit-box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.06)
    box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.06)

    @include media(screen and (min-width: 500px))
      flex-basis: calc(50% - 30px)

    @include media(screen and (min-width: 740px))
      flex-basis: calc(33% - 30px)

    @include media(screen and (min-width: 1000px))
      flex-basis: calc(25% - 30px)

    .wrapper
      padding: 20px
      display: flex
      max-width: 320px
      align-items: center
      flex-direction: column
      justify-content: center

      .chart-wrapper
        width: 100%
        flex: 1
        min-height: 0
        padding-top: 10px

        .left-link
          left: 0
          width: 50%
          height: 80%
          z-index: 1000
          position: absolute

        .right-link
          left: 50%
          width: 50%
          height: 80%
          z-index: 1000
          position: absolute

        .single-link
          width: 85%
          height: 80%
          z-index: 1000
          position: absolute

        .arrow-right
          background: url('../../../assets/arrow-right.png')
          background-size: cover
          background-position: 50% 50%
          position: absolute
          transform: scale(1.0, 0.8)
          top: 35%
          left: 35%
          width: 30%
          height: 30%

        .arrow-left
          background: url('../../../assets/arrow-left.png')
          background-size: cover
          background-position: 50% 50%
          position: absolute
          transform: scale(1.0, 0.8)
          top: 35%
          left: 35%
          width: 30%
          height: 30%

        .arrow-both
          background: url('../../../assets/arrow-both.png')
          background-size: contain
          background-repeat: no-repeat
          background-position: 50% 50%
          position: absolute
          top: 25%
          left: 25%
          width: 50%
          height: 50%

        .chart-title
          font-family: 'Stolzl'
          text-align: center
          position: relative
          left: 50%
          color: $color-text
          transform: translateX(-50%)

          h4
            font-size: 13px
            line-height: 1
            font-weight: $font-medium
            margin-bottom: 5px

</style>



// WEBPACK FOOTER //
// src/components/pages/Dashboard/ChartItemLink_v2.vue